module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n6r8n7r-d0c05ed9c6a6cb159b379286ddd0072c.svg";